

// import { EaseApp } from "chat-uikit";
import { EaseApp } from "agora-chat-uikit";

// const WebIM = EaseApp.getSdk({ appkey: "411104643#1292073" })
// EaseApp.thread.setHasThreadEditPanel(true)

// export default WebIM;
